<template>
  <b-modal :id="id" hide-header hide-footer centered>
    <div class="success-body">
      <span class="close-ico" @click="$bvModal.hide(id)">
        <img src="@/assets/img/home/close-circle-icon.png" alt="" />
      </span>
      <!-- <img class="ballon-img" src="@/assets/img/home/success-image.png" alt="">-->
      <div class="ballon-img">
        <vLottiePlayer
          height="300px"
          width="300px"
          name="clap"
          :autoplay="true"
          loop
          :animationData="require('@/assets/lotties/ballons.json')"
        />
      </div>
      <h3>Success!!</h3>
      <div class="invite">You are all set!</div>
      <div v-if="false" class="send-list">
        Please check your email (including spam folder) for an invite letter.
      </div>
      <div v-else>
        We look forward to you joining us on this momentous occasion.
      </div>
    </div>
  </b-modal>
</template>

<script>
import VueLottiePlayer from "vue-lottie-player";
export default {
  name: "SuccessModal",
  components: {
    vLottiePlayer: VueLottiePlayer
  },
  props: {
    id: {
      type: String,
      required: true
    },
    position: {
      required: true
    }
  },
  computed: {
    totalBeta() {
      return (this.position + 3000)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>

<style lang="scss" scoped>
.success-body {
  position: relative;
  .close-ico {
    position: absolute;
    top: 0px;
    right: 0px;
    cursor: pointer;
  }
  .ballon-img {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translate(-50%, -100%);
  }
  h3 {
    padding-top: 40px;
    font-weight: bold;
    font-size: 40px;
    line-height: 55px;
    color: #fe818b;
    text-align: center;
    margin-bottom: 0;
  }
  .pos-line {
    margin-top: 22px;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    text-align: center;
    color: #52595e;

    .position {
      height: 37px;
      background: #65ea82;
      box-shadow: 0px 4px 16px rgba(101, 234, 130, 0.4);
      border-radius: 32px;
      //display: flex;
      //justify-content: center;
      //align-items: center;
      padding: 0 10px;
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      text-align: center;
      color: #ffffff;
    }
  }
  .invite {
    margin-top: 13px;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    text-align: center;
    color: #52595e;
  }
  .send-list {
    margin-top: 22px;
    font-style: italic;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #52595e;
    padding-bottom: 36px;
  }
}
</style>
